import * as catalogos from 'app/idiomas/i18n/perfiles/catalogos/tr';
export const locale = {
  lang: 'tr',
  data: {
    'RAWDATA': {
      'CATALOGOS': {
        'broker': catalogos.institutos,
      },
      'TITULO': 'RawData\'ya danışın',
      'SUBTITULO': 'Belirli bir dönemde platformda oluşturulan anketlerin Ham Veri bilgilerine bakın.',
      'NOFILE': 'Oluşturulmadı',
      'FILTER': 'Şirkete göre filtrele',
      'DOWNLOADFILE': 'Dosyayı indir',
      'CAMPOS': {
        'anio': 'Yıl',
        'broker': 'Komisyoncu',
        'brokerCountry': 'Aracı ülke',
        'anioRanking': 'Yıl sıralaması',
      },
      'COLUMNAS': {
        'nombre': 'Şirket',
        'producto': 'Ürün tipi',
        'surveytoken': 'Anket Simgesi',
        'fecha': 'Tarih',
        'acciones': 'İşlenmemiş veri',
      },
      'RESULTADOS': {
        'CARGANDO': 'Arama sonuçları yükleniyor',
        'TITULO': 'Sonuçlar',
        'ENCONTRADAS': 'Bulunan toplam anket sayısı',
        'DESCARGAR': 'Bilgileri Excel biçiminde indirme',
        'SINRESULTADOS': 'Belirtilen parametrelerle oluşturulmuş anket bulunamadı'
      }
    }
  }
};
